/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ImportScriptForm } from '../models/ImportScriptForm';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ScriptImportControllerService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static importScript({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ImportScriptForm,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/scripts/import/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
